import styled from 'styled-components';

export const Container = styled.div`
  max-width: 800px; 
  width: 100%;
  margin: 40px auto; 
  padding: 30px; 
  background-color: #fff; 
  border-radius: 10px; 
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); 
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  width: 100%;
  padding-bottom: 80px; /* Espacio para los botones */
`;

export const Title = styled.h2`
  color: #00608a;
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: #6c757d;
  font-size: 16px;
  margin-bottom: 30px;
  text-align: center;
`;

export const AuthMessage = styled.p`
  color: ${props => props.error ? '#ff4d4d' : '#28a745'};
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  color: #212529;
  display: block;
  font-size: 16px;
  margin-top: 40px;
  margin-bottom: 5px;
`;

export const Input = styled.input`
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 16px;
  padding: 10px;
  width: 100%;
`;

export const Spacer = styled.div`
  height: 100px;
`;

export const Divider = styled.hr`
  border: 0;
  border-top: 1px solid #e9ecef;
  margin: 20px 0;
`;

/*export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
`;*/

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap; /* Permite que los botones se acomoden en móviles */

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 10px; /* Reduce espacio entre botones */
  }
`;

/*export const Button = styled.button`
  background-color: ${props => props.secondary ? '#fff' : '#00cfd4'};
  border: ${props => props.secondary ? '1px solid #6c757d' : 'none'};
  border-radius: 20px;
  color: ${props => props.secondary ? '#6c757d' : '#fff'};
  cursor: pointer;
  font-size: 16px;
  padding: 10px 20px;
  min-width: 150px;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${props => props.secondary ? '#f8f9fa' : '#00bfc4'};
  }

  &:disabled {
    background-color: #e9ecef;
    color: #6c757d;
    cursor: not-allowed;
  }
`;*/

export const Button = styled.button`
  background-color: ${(props) => (props.secondary ? "#fff" : "#00cfd4")};
  border: ${(props) => (props.secondary ? "1px solid #6c757d" : "none")};
  color: ${(props) => (props.secondary ? "#6c757d" : "#fff")};
  padding: 10px 20px;
  border-radius: 20px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  min-width: 150px;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${(props) => (props.secondary ? "#f8f9fa" : "#00bfc4")};
  }

  &:disabled {
    background-color: #e9ecef;
    color: #6c757d;
  }
`;


// Nuevos estilos añadidos
/*export const RadioGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
`;*/

export const RadioGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap; /* Evita desbordes */

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 15px; /* Reduce espacio en móviles */
    align-items: center;
  }
`;

export const RadioButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const RadioInput = styled.input`
  display: none;
`;

/*export const RadioLabel = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  background-color: ${(props) => (props.isSelected ? '#00cfd4' : '#f1f1f1')};
  padding: 20px;
  border-radius: 15px;
  transition: all 0.3s ease;

  img {
    width: 100px;
    height: 100px;
    margin-bottom: 10px;
    transition: all 0.3s ease;
  }

  span {
    font-size: 16px;
    color: #212529;
  }

  &:hover {
    background-color: #00bfc4;
  }
`; */

export const RadioLabel = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  background-color: ${(props) => (props.isSelected ? '#00cfd4' : '#f1f1f1')};
  padding: 20px;
  border-radius: 15px;
  transition: all 0.3s ease;
  width: 100%; /* Que se adapte al contenedor */

  img {
    width: 80px; /* Ajuste para evitar tamaños fijos */
    height: auto;
    max-width: 100%;
    margin-bottom: 10px;
    transition: all 0.3s ease;

    @media (max-width: 600px) {
      width: 60px; /* Reduce tamaño en móviles */
    }
  }

  span {
    font-size: 16px;
    color: #212529;
  }

  &:hover {
    background-color: #00bfc4;
  }
`;

/* export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  padding: 20px 0;
  background-color: white;
  width: 100%;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  margin-top: 20px; 
`;  */

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  padding: 20px 0;
  background-color: white;
  width: 100%;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  margin-top: 20px; /* 🔹 Se ajusta para más separación */
`;

export const DireccionBox = styled.div`
  display: flex;
  align-items: center;
  background-color: #e0f7fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 30px; /* 🔹 Se aumenta la separación */
`;